"use client";
import {NeoButton, NeoDatePicker} from "@/components/forms";
import {NeoSwitchInput} from "@/components/shared/neo-switch/neo-switch-input";
import {Image} from "@nextui-org/react";
import {useForm} from "react-hook-form";

/**
 * TODO: @selva,@surya,@arun
 * Create a Validation Schema if you have a form & inject them
 */
export const TripsFilter: React.FC<TripsFilterProps> = () => {
  const {register, handleSubmit, setValue} = useForm();

  // Handle switch input change and update form value
  const handleSwitchChange = (name: string, value: boolean) => {
    setValue(name, value);
  };

  const onSubmit = (event: any) => {
    //handle Filter functionality
  };

  const onDateChange = (name: string, event: any) => {
    setValue(name, event);
  };

  return (
    <>
      <form
        onSubmit={handleSubmit(event => {
          onSubmit(event);
        })}
      >
        <div className="flex w-[350px] flex-col gap-5 p-2">
          <NeoDatePicker
            label="Trip Range"
            range
            showTime
            handleDateChange={e => onDateChange("refTripRange", e)}
          />
          <NeoSwitchInput
            label="Trip Type "
            activeLabel="Planned"
            inActiveLabel="Unplanned"
            onValueChange={value => handleSwitchChange("tripType", value)}
          />
          <NeoSwitchInput
            label="Status"
            activeLabel="Active"
            inActiveLabel="Inactive"
            onValueChange={value => handleSwitchChange("status", value)}
          />
          <div className="w-100 flex justify-end">
            <NeoButton
              type="submit"
              color="yellow"
              className="gap-[5px] text-lg"
              startContent={
                <Image
                  className="h-5 w-5"
                  src="/icons/filter.svg"
                  alt="filter"
                />
              }
            >
              Filter
            </NeoButton>
          </div>
        </div>
      </form>
    </>
  );
};
